import { GetState } from 'zustand';
import getLedspClient from '../../../../utils/get-ledsp-client';
import { ICountdown } from '../../concepts/countdown';
import { IDocs } from '../../concepts/docs';
import { IGame } from '../../concepts/game';
import { ILocations } from '../../concepts/locations';
import { IPlayer } from '../../concepts/player';
import { IToDos, VotingPayload } from '../../concepts/to-dos';
import { IVoting } from '../../concepts/voting';
import { IPhaseExecutorFn } from '../game';

export const startPhase1Outcome: IPhaseExecutorFn = (
  get: GetState<
    IGame & IDocs & IToDos & ILocations & IVoting & IPlayer & ICountdown
  >
) => {
  get().openLocation('phases/phase-1/outcome');
  get().openLocation('phases/phase-1/survey');

  get().clearToDos();
  ToDos.forEach(get().appendToDo);

  get().startVotingSession('phase-1-survey-satisfaction', {
    availableVotes: ['1', '2', '3', '4', '5'],
    voters: get().players,
    isMotivationRequired: false,
  });

  get().startVotingSession('phase-1-survey-representation', {
    availableVotes: ['1', '2', '3', '4', '5'],
    voters: get().players,
    isMotivationRequired: false,
  });

  get().appendToDo<VotingPayload>({
    id: 'vote-phase-1-survey',
    type: 'vote',
    locationToVisit: 'phases/phase-1/survey',
    nudge: '',
    payload: {
      sessions: [
        'phase-1-survey-satisfaction',
        'phase-1-survey-representation',
      ],
      gotoPhase: 'phase-1-end',
    },
  });

  get().stopCountdown();

  getLedspClient().sendGameProgressEvent({
    step: 'Phase1',
    stage: 'VoteResults',
    gameId: get().gameId,
    playerId: get().playerId,
    teamId: get().team,
    eventType: 'game-stage-entered',
  });
};

const ToDos = [
  {
    id: 'read-vote',
    type: 'read-info',
    locationToVisit: 'phases/phase-1/outcome',
    payload: null,
    nudge: '',
  },
  {
    id: 'read-vote',
    type: 'read-info',
    locationToVisit: 'phases/phase-1/survey',
    payload: null,
    nudge: '',
  },
];
